/*export let defaultVariables = {
    url: "http://127.0.0.1:8000/api",
    backend: "http://127.0.0.1:8000/",
    uploads: "http://127.0.0.1:8000/uploads",
    React:"http://localhost:3000",
    website: "http://localhost:3000",
};*/

export let defaultVariables = {
  // url: "http://127.0.0.1:8000/api",
  // backend: "http://127.0.0.1:8000/",
  // uploads: "http://127.0.0.1:8000/uploads",
  url: "https://api.kolaydoy.net/api",
  backend: "https://api.kolaydoy.net/",
  uploads: "https://api.kolaydoy.net/uploads",
  // React: "http://localhost:3000",
  // website: "http://localhost:3000",
  React: "https://kolaydoy.net",
  website: "https://kolaydoy.net",
};
